<template>
  <div
    ref="scroller"
    class="w-full h-full overflow-scroll"
    :style="{
      'padding-top': setyleNavHeight + 'px'
    }"
  >
    <div class="max-w-960 min-h-full mx-auto bg-white text-gray-900 p-4 md:p-0">
      <div class="title relative mt-12 md:mt-18">
        <img src="./assets/logo.svg" class="absolute -bottom-1 w-20 md:w-28" alt="目录" />
        <span
          class="inline-block ml-24 md:ml-32 text-2xl mb-2 md:mb-4 font-medium truncate max-w-7/10"
          >{{ sequence.contents[0] && sequence.contents[0].title }}</span
        >
      </div>
      <div class="mt-8 md:mt-14">
        <SceneCard
          v-for="(chapter, chapterIndex) in sequence.contents[0] && sequence.contents[0].chapters"
          :key="chapterIndex"
          :chapter="chapter"
          :chapterIndex="chapterIndex + 1"
          class="mb-4 md:mb-8"
          :disabeld="
            sequentialRead && !sequence.contents[0]['chapter_' + chapterIndex] && chapterIndex !== 0
          "
          @sceneCall="sceneCall"
        />
      </div>
    </div>
    <!-- 重新学习按钮组 -->
    <div class="multifunction-slot">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { Content, Sequence } from '@forchange/storytime';
import { SceneCard } from '@/components/resources';
import { trackCallStack, TrackHistory } from '@forchange/storytime/lib/track';
import { Chapter } from '@/components/resources/scene/SceneCard/index.vue';
import ScrollListenMixin from '@/mixins/scrollListen';

export type FragmentHistory = {
  headId: string;
  history: Array<TrackHistory>;
};

@Component({
  components: {
    SceneCard
  }
})
export default class Scene extends Mixins(ScrollListenMixin) {
  @Prop({ type: Object }) sequence!: Sequence & {
    $id: string;
    contents: Array<
      Content & {
        currentChapterIndex?: number;
        chapters: Array<Chapter>;
        sequentialRead: true | '是';
      }
    >;
  };

  get sequentialRead() {
    return ['是', true].includes(this.sequence.contents[0].sequentialRead);
  }

  mounted() {
    this.initScrollListen(this.$refs.scroller as HTMLElement);
    this.$nextTick(() => {
      this.initSceneHistory();
    });
  }

  initSceneHistory() {
    const content = this.sequence.contents[0];

    if (!content.currentChapterIndex) return;

    const chapter =
      content.currentChapterIndex && content.chapters[content.currentChapterIndex - 1];
    if (!chapter) return;

    // 获取Track记录
    const storeTrack = window.storyteller.getTrack();
    if (storeTrack.trackCallStack.isEmpty) return;
    const trachList = this.wipeTrachList(this.findTargetTrack(storeTrack.trackCallStack, chapter));
    const isCurrentTrach = trachList?.some((item) => {
      return item.$id.split('#')[0] === chapter.path;
    });

    // 符合则进行更新
    if (isCurrentTrach) {
      window.storyteller.updateAssignContent({
        $id: content.$id,
        $kind: content.$kind,
        ...{
          [`chapter_${content.currentChapterIndex}`]: {
            headId: trachList[trachList.length - 1].$id,
            history: [...trachList]
          },
          currentChapterIndex: undefined
        }
      });
    }
  }

  wipeTrachList(trachList: Array<TrackHistory>): Array<TrackHistory> {
    if (trachList[0]?.type === 'call') {
      trachList.shift();
    }

    if (['jump', 'call'].includes(trachList[trachList.length - 1]?.type)) {
      trachList.pop();
    }
    return trachList;
  }

  findTargetTrack(storeTrachStack: trackCallStack, chapter: Chapter): Array<TrackHistory> {
    const topTrack = storeTrachStack.top();
    const isCurrentTrack = topTrack?.some((item) => {
      return item.$id.split('#')[0] === chapter.path;
    });
    if (storeTrachStack.isEmpty) return [];
    const popList = [...storeTrachStack.pop()];
    if (isCurrentTrack) {
      return popList;
    } else {
      return [...this.findTargetTrack(storeTrachStack, chapter), ...popList];
    }
  }

  sceneCall(callData: { index: number; path: string }) {
    window.storyteller.updateAssignContent({
      $id: this.sequence.contents[0].$id,
      $kind: this.sequence.contents[0].$kind,
      ...{
        currentChapterIndex: callData.index
      }
    });
    window.storyteller.call({
      path: callData.path,
      notAotuCall: true
    });
    window.next();
    const currentHistory = this.getHistory(callData.index);
    if (currentHistory) return this.callHistory(currentHistory);
  }

  callHistory(fragmentHistory: FragmentHistory) {
    window.storyteller.callHistory([...fragmentHistory.history], fragmentHistory.headId);
  }

  getHistory(index: number): FragmentHistory | undefined {
    // 采用动态key值 减少历史记录大小
    return (this.sequence.contents[0] as any)[`chapter_${index}`] as FragmentHistory;
  }
}
</script>
<style scoped>
.title {
  border-bottom: 1px solid rgba(151, 151, 151, 0.12);
}

/* slot position */
.multifunction-slot {
  @apply fixed right-4 bottom-16;
}
</style>
